export const SYSTEM_USER_ID = '627c059523385e117fd70dc0';
export const GLOBAL_ADMIN_GROUP_ID = '626248755de51212aea324e8';

export const ANONYMOUS_NAME = 'anonymous';
export const ANONYMOUS_USER_EMAIL = 'anonymous@serviceplanmakeos.com';
